export const getFullName = (fn?: string, ln?: string) => {
  return [fn, ln].filter(Boolean).join(' ');
};

export const getAvatarContent = (fn?: string, ln?: string) => {
  if (!fn || !ln) return '';

  return `${fn[0].toUpperCase()}${ln[0].toUpperCase()}`;
};

export const getCreatorFullName = (fullName?: string) => {
  return fullName || 'Not specified';
};
